import { styled } from "@vitality-ds/system";
import BaseCalloutStyles from "./styles/BaseCallout.styles";
import BaseCalloutActionsStyles from "./styles/BaseCalloutActions.styles";
import BaseCalloutIconContainerStyles from "./styles/BaseCalloutIconContainer.styles";
import BaseCalloutTitleContainerStyles from "./styles/BaseCalloutTitleContainer.styles";
export var BaseCallout = styled("div", BaseCalloutStyles);
export var BaseCalloutActions = styled("div", BaseCalloutActionsStyles);
export var BaseCalloutIconContainer = styled("div", BaseCalloutIconContainerStyles);
export var BaseCalloutTitleContainer = styled("div", BaseCalloutTitleContainerStyles);